import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import moment from "moment";
import _ from 'lodash';
import 'moment-timezone';
import { dateAccessHelper } from '../helpers/accessHelper';
import { spaceToUnderscore } from '../helpers/helpers';

const timezone = 'America/New_York';

class StudentHomeView extends Component {

    constructor(props) {
        super (props);
    }

    render() {
        const { assignments, dropbox, expanded, semesters } = this.props;

        let semester = semesters[dropbox.semester.id];

        return (
            <div className="card" key={dropbox.id}>
                <div className="card-header" role="tab">
                    <h5 className="mb-0">
                        <Link data-toggle="collapse"
                              to={'#collapse' + dropbox.id} aria-expanded="true"
                              aria-controls={'collapse' + dropbox.id}>
                            <i className="fa fa-book" aria-hidden="true"/>&nbsp;
                            {dropbox.name}
                            <span className="float-right">
                                <span className="mr-2"/>
                                <span>
                                    {semester.season}
                                </span>
                                -
                                <span>
                                    {semester.year}
                                </span>
                            </span>
                        </Link>
                    </h5>
                </div>
                <div
                    id={'collapse' + dropbox.id}
                    className={parseInt(expanded) === parseInt(dropbox.id) ? 'show' : 'collapse'}
                    role="tabpanel"
                    aria-labelledby={'heading' + dropbox.id}
                >
                    <div className="card-block">
                        <table className="table course-list">
                            <thead>
                            <tr className="course-list-header">
                                <th>Assignment</th>
                                <th>Due Date</th>
                                <th>Status</th>
                                <th>Assignment Type</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                _.map(_.sortBy(assignments, ['due_date', 'name']), (assignment) => {
                                    let isAccessible = false;
                                    (assignment.use_date_control
                                        ? isAccessible = dateAccessHelper(assignment.access_open_date, assignment.access_close_date)
                                        : [assignment.access_enabled
                                            ? isAccessible = true
                                            : isAccessible = false
                                        ]
                                    );
                                    return (
                                        <tr key={assignment.id}>
                                            <td>
                                                <Link
                                                    to={`/${dropbox.name}/${spaceToUnderscore(assignment.name)}`}
                                                >
                                                    {assignment.name}
                                                </Link>
                                            </td>
                                            <td>
                                                {moment(assignment.due_date).tz(timezone).format('MM-DD-YYYY h:mm:ss a')}
                                            </td>
                                            <td>
                                                {
                                                    assignment.use_date_control
                                                    ?
                                                    [
                                                        isAccessible
                                                        ?
                                                            <i
                                                                key={assignment.id}
                                                                className="assignment-green fa fa-calendar"
                                                                aria-hidden="true"
                                                            />
                                                        :
                                                            <i
                                                                key={assignment.id}
                                                                className="assignment-red fa fa-calendar"
                                                                aria-hidden="true"
                                                            />
                                                    ] : [
                                                        assignment.access_enabled
                                                        ?
                                                            <i
                                                                key={assignment.id}
                                                                className="assignment-green fa fa-check"
                                                                aria-hidden="true"
                                                            />
                                                        :
                                                            <i
                                                                key={assignment.id}
                                                                className="assignment-red fa fa-minus-circle"
                                                                aria-hidden="true"
                                                            />
                                                    ]
                                                }
                                            </td>
                                            <td>
                                                {
                                                    assignment.group_submission
                                                    ? (
                                                        <span>
                                                            <Link to={`/${dropbox.name}/${spaceToUnderscore(assignment.name)}/group`}>
                                                                <i className="fa fa-users" aria-hidden="true"/>
                                                            </Link>
                                                        </span>
                                                    ) : (
                                                        <i className="fa fa-user" aria-hidden="true"/>
                                                    )
                                                }
                                            </td>
                                        </tr>
                                    );
                                })
                            }
                            </tbody>
                        </table>
                        <span className="table-rounded-bottom" />
                    </div>
                </div>
            </div>
        );
    }
}

StudentHomeView.propTypes = {
    assignments: PropTypes.object.isRequired,
    dropbox: PropTypes.object.isRequired,
    expanded: PropTypes.string,
    semesters: PropTypes.object.isRequired,
};

export default StudentHomeView;



/** WEBPACK FOOTER **
 ** ./src/components/StudentHomeView.js
 **/